import {Box, CircularProgress, Typography} from '@mui/material';
import {useTheme} from "@mui/material/styles";

export const SplashScreen = () => {
    let theme = useTheme()
    return <Box
        sx={{
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // สีเทาๆโปร่งแสง
            backdropFilter: 'blur(10px)', // สร้างเอฟเฟกต์ blur ให้กับพื้นหลัง
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            justifyContent: 'center',
            left: 0,
            p: 3,
            position: 'fixed',
            top: 0,
            width: '100vw',
            zIndex: 1400,
            color: 'white'
        }}
    >
        <CircularProgress sx={{color: `${theme.palette.primary.main}`}} size={120}/>
        <Typography position="absolute" fontWeight={"bold"}> Loading... </Typography>
    </Box>
};
